/**
 * The care-gap measures primary can ask the predict service to evaluate. primary owns this
 * vocabulary — its predict client sends these values as `careGapTypes`. Flow references them
 * in its care-gap block.
 */
export var CareGapAlgorithm;
(function (CareGapAlgorithm) {
    CareGapAlgorithm["BloodPressureControlDiabetes"] = "BLOOD_PRESSURE_CONTROL_DIABETES";
    CareGapAlgorithm["CervicalCancerScreening"] = "CERVICAL_CANCER_SCREENING";
    CareGapAlgorithm["ColonCancerHighRisk"] = "COLON_CANCER_SCREEN_HIGH_RISK";
    CareGapAlgorithm["DiabetesEyeExam"] = "DIABETES_EYE_EXAM";
    CareGapAlgorithm["DiabetesHbA1cMonitoring"] = "DIABETES_HBA1C_MONITORING";
    CareGapAlgorithm["DiabetesNephropathyMonitoring"] = "DIABETES_NEPHROPATHY_MONITORING";
    CareGapAlgorithm["Hypertension"] = "HYPERTENSION";
    CareGapAlgorithm["KidneyHealthEvaluationDiabetes"] = "KIDNEY_HEALTH_EVALUATION_FOR_PATIENTS_WITH_DIABETES";
    CareGapAlgorithm["OsteoporosisScreeningOlderWomen"] = "OSTEOPOROSIS_SCREENING_OLDER_WOMEN";
    CareGapAlgorithm["PreventiveCareBreastCancerScreeningForWomenFrom50To75"] = "PREVENTIVE_CARE_BREAST_CANCER_SCREENING_RECOMMENDED_EVERY_1_2_YEARS_FOR_WOMEN_BETWEEN_AGES 50_75_YEARS";
    CareGapAlgorithm["PreventiveCareColonCancerScreen"] = "PREVENTIVE_CARE_COLON_CANCER_SCREEN";
    CareGapAlgorithm["PreventiveCarePapSmear"] = "PREVENTIVE_CARE_PAP_SMEAR";
    CareGapAlgorithm["StatinTherapyCardiovascular"] = "STATIN_THERAPY_CARDIOVASCULAR";
    CareGapAlgorithm["StatinTherapyDiabetes"] = "STATIN_THERAPY_DIABETES";
})(CareGapAlgorithm || (CareGapAlgorithm = {}));
//# sourceMappingURL=algorithm.js.map